
import { Entity } from '../entity';
import { CodeType } from '../shared/code.type';
import { CodeUoM } from '../shared/uom';
import { CodeCategory, CodeInvoiceStatus } from '../shared/code';

export interface JobTemplateCode {
    _id: string;
    name: string;
    quantity: number;
    location?: string;
    description?: string;
    longDescription?: string;
    canOverrideDesc?: boolean;

    selected?: boolean;
    category?: CodeCategory;
    codeUoM?: CodeUoM;

    buyPrice?: number;
    sellPrice: number;

    customBuyPrice?: boolean;
    customSellPrice?: boolean;

    note?: string;
    codeInvoicingStatus?: CodeInvoiceStatus;
    suppliedBySubcontractor?: boolean;

    type?: CodeType;
}

export interface JobTemplateWorkOrder {
    _id: string;
    name: string;
    codes: JobTemplateCode[];
    customFields?: any;
    workCategory?: Entity;
    estimatedDuration?: number;
    labels?: Entity[];
    sortOrder?: string;
}

export interface JobTemplateWorkOrderValidateRequest {
    jobId: string;
    workOrderId: string;
    workOrderName: string;
}

/**
 * Board commands for the Recurring Job items surface.
 *
 * Mirrors {@link JobItemCommandId}: the board never patches the recurring job generically — items
 * live in `jobTemplate.template.workOrders[].codes[]`, so a generic write keyed by item id would
 * resolve the wrong document. Every mutation enters through one of these.
 */
export enum RecurringJobTemplateItemCommandId {
    AddItems = 'AddItems',
    UpdateItem = 'UpdateItem',
    DeleteItem = 'DeleteItem',
}
